module.exports = __webpack_public_path__ + "static/media/ReceiptScreen.16fc4c52.png";